import angular from "angular";
import panel from "../services";

function chatIsTyping (panel) {

    return function(scope, element, attrs) {
        var register_id = parseInt(panel.getUser().register_id);
        var ws = false;
        var stillStyping;

        scope.isTyping = function(data){
            if(data.sender != register_id) {
                data.typing ? $('.recipient-is-typing').show() : $('.recipient-is-typing').hide();
            }
        };

        panel.getWSObject('chat', function(socket){
            socket.addToSpace('chat', 'isTyping');
            socket.registerHandler('isTyping', {
                'callback': scope.isTyping,
                'scope': scope
            });
            ws = socket.getSocket();
        });

        $(element).keydown(() => {
            if(ws){
                var msg = {handler:'isTyping',sender:register_id,recipient:parseInt(attrs['person'])};
                clearTimeout(stillStyping);
                msg.typing = true;
                ws.emit('cmd', {type: 'TYPING', MSG: msg});
                stillStyping=setTimeout(() => {
                    msg.typing = false;
                    ws.emit('cmd', {type: 'TYPING', MSG: msg});
                },1000);
            }
        });
    }
}

export default angular.module('directives.chatIsTyping', [panel]).directive('chatIsTyping', chatIsTyping).name;


// WEBPACK FOOTER //
// ./src/app/directives/chatIsTyping.js